export default __webpack_public_path__ + "static/media/logo-invert.fc04a2c3.png";